<template>
<!-- 客户代购单 -->
<section class="viewContainer">
  <!-- 搜索/查询 -->
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
        <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"/>
    </div>
    <el-collapse-transition>
    <div v-show="show3">
      <!-- 上 -->
      <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
        <!-- 顶部搜索框 -->
        <el-form-item label="代购单号：" style="width:33%;display:flex">
          <el-input v-model="filters.purchasingNo" placeholder="请输入客户代购单号" maxlength="20" style="width:90%"/>
        </el-form-item>
        <el-form-item label="所属城市：" style="width:33%;display:flex">
          <el-cascader placeholder="请选择城市" v-model="filters.chengshi" style="width:90%"
          :options="options" filterable clearable @change="handleChange"/>
        </el-form-item>
        <el-form-item label="代购状态：" style="width:33%;display:flex">
          <el-select v-model="filters.statusId" placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 下 -->
      <el-form :inline="true" :model="filters" style="margin-top:10px;display:flex;" class="findform">
        <el-form-item label="客户电话：" style="width:33%;display:flex">
          <el-input placeholder="请输入联系电话" v-model="filters.phone" maxlength="11" style="width:90%" onkeyup="value=value.replace(/^\D*(\d*(?:\d{0})?).*$/g, '$1')" />
        </el-form-item>
        <el-form-item label="代　购　价：" style="width:33%;display:flex">
          <div style="width:90%;display:flex;justify-content:space-between;">
            <el-input placeholder="请输入预算范围" v-model="filters.minPurchasingPrice" maxlength="9"
            type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            <label style="margin: 0 5px">　至　</label>
            <el-input placeholder="请输入预算范围" v-model="filters.maxPurchasingPrice" maxlength="9"
            type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
          </div>
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      </el-form>
    </div>
    </el-collapse-transition>
  </div>
  <!--列表-->
  <div class="main_container">
    <section class="model_section">
      <el-col :span="18">
        <p class="model_top_title">客户代购单</p>
      </el-col>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dataList" stripe border>
        <el-table-column label="序号" align="center" width="60px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="代购单号" align="center">
          <template scope="scope">
            <span :title="scope.row.PurchasingNo" :label="scope.row.PurchasingNo">{{scope.row.PurchasingNo}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户姓名" align="center">
          <template scope="scope">
            <span :title="scope.row.UserName" :label="scope.row.UserName">{{scope.row.UserName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户电话" align="center">
          <template scope="scope">
            <span :title="scope.row.Phone" :label="scope.row.Phone">{{scope.row.Phone}}</span>
          </template>
        </el-table-column>
        <el-table-column label="代购总金额" align="center">
          <template scope="scope">
            <span :title="scope.row.FinalPrice" :label="scope.row.FinalPrice">{{scope.row.FinalPrice}}</span>
          </template>
        </el-table-column>
        <el-table-column label="所在城区" align="center">
          <template scope="scope">
            <span :title="scope.row.CityName" :label="scope.row.CityName">{{scope.row.CityName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">
            <span :title="scope.row.StatusName" :label="scope.row.StatusName">{{scope.row.StatusName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="seeOrder(scope.row.Id)" class="handle">
              <i class="el-icon-view"></i>查看
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
    </div>
  </div>

  <!-- 抽屉详情 -->
  <el-drawer :visible.sync="PurchasingAgentDialog" :show-close= false size="35%">
    <template v-slot:title>
      <ul class="drawer_title">
        <li>代购单号: {{orderdetailList.PurchasingNo}}</li>
        <li>
          <el-button type="danger" @click="cancelForm" style="margin-top: -10px;">关 闭</el-button>
        </li>
      </ul>
    </template>
    <div class="drawer_div">
      <!-- 订单信息 -->
      <div class="divHone"><div>代购信息</div> <div>{{orderdetailList.StatusName}}</div></div>
        <div style="display:flex;flex-wrap: wrap;">
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">所在城区：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.CityName}}</p>
          </span>
          <!-- <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">配送地址：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.DeliveryAddress}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">上楼方式：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.UpstairsTypeName}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">楼层：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.FloorNumberName}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">是否需要安装：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.NeedInstallation}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">运费承担：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.BearDeliveryFee}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">期望送货日期：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.DeliveryDate}}</p>
          </span>
          <span style="width:33%;display:flex" v-if="orderdetailList.StatusName != '代购中'">
            <p style="white-space: nowrap;" class="watch_first">代购商品市场总价：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.FinalPrice}}</p>
          </span> -->
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">代购总价：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.FinalPrice}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">代购服务费：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.ServiceFeeName}}</p>
          </span>
          <span style="width:33%;display:flex">
            <p style="white-space: nowrap;" class="watch_first">备注：</p>
            <p style="width:85%;word-wrap: break-word;">{{orderdetailList.Remark}}</p>
          </span>
        </div>
        <!-- 表格 -->
        <!-- <div class="purchasingGoods">代购商品</div>
        <el-table :data="formDetails"  class="watch_tab" stripe border style ="margin-top:15px">
          <el-table-column prop="GoodModelCode" label="商品名称"  align="center">
            <template scope="scope"><span>{{scope.row.GoodsName}}</span></template>
          </el-table-column>
          <el-table-column prop="GoodModelCode" label="商品型号"  align="center">
            <template scope="scope"><span>{{scope.row.GoodsCode}}</span></template>
          </el-table-column>
          <el-table-column prop="Counts" label="所属品类" align="center">
            <template scope="scope"><span>{{scope.row.GoodsBrandTypeName}}</span></template>
          </el-table-column>
          <el-table-column prop="singleprice" label="所属品牌"  align="center">
            <template scope="scope"><span>{{scope.row.BrandName}}</span></template>
          </el-table-column>
          <el-table-column prop="Counts" label="数量" align="center">
            <template scope="scope"><span>{{scope.row.Quantity}}</span></template>
          </el-table-column>
          <el-table-column prop="PaidPrice" label="代购价" align="center">
            <template scope="scope"><span>{{scope.row.GoodsPrice}}</span></template>
          </el-table-column>
          <el-table-column prop="PaidPrice" label="图片" align="center">
            <template scope="scope">
              <span @click="seePicture(scope.row)" :style="{color: scope.row.ImgUrlList ? '#F56C6C' : '#ccc'}">{{scope.row.GoodsImagesCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Counts" label="备注" align="center">
            <template scope="scope"><span>{{scope.row.Remark}}</span></template>
          </el-table-column>
        </el-table> -->
        <div class="purchasingGoods">代购协议合同</div>
        <div class="upPictures">
          <!-- 上传图片 -->
          <el-upload v-show="orderdetailList.StatusName == '代购中'" action multiple v-if="flag < 5"
          :before-upload="beforeAvatarUpload" accept=".png, .jpg,.jpeg" class="daigouUp">
            <i class="el-icon-plus avatar-uploader-icon"/>
          </el-upload>
          <div class="daigouUp" v-for="(item,index) in detailImgUrlarr" :key="index" :data-img="item">
            <el-image :src="item.ImgUrl" style="width: 80px; height:80px" @click="handleClickItem" :preview-src-list="[item.ImgUrl]"/>
          </div>
        </div>
        <div class="divP">
          <p v-if="orderdetailList.StatusName == '代购中'">请上传代购协议合同</p>
          <p v-else>代购协议合同</p>
        </div>
      <div class="purchasingGoods">代购清单</div>
      <div class="detailedListBottom">
        <div class="daigouUp" v-for="(item,index) in PurchasingGoodsListsImages" :key="index" :data-img="item">
          <el-image :src="item.ImgUrl" style="width: 80px; height:80px" @click="handleClickItem" :preview-src-list="[item.ImgUrl]"/>
        </div>
      </div>
      <div class="drawer_foot" v-if="orderdetailList.StatusName == '代购中'">
        <div class="labelInput">
          <label>最终代购价:　</label>
          <el-input placeholder="请输入最终代购价" v-model="finalPurchasePrice" maxlength="9"
            type="text" onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
            style="width: 30%"/>
          <label>　最终代购服务费: <strong>{{monitorServiceCharge.toFixed(2)}}</strong></label>
        </div>
        <el-button type="danger" @click="endUploadContract">已找到合适的商品且与客户沟通确认,上传代购协议合同</el-button>
      </div>
    </div>
  </el-drawer>
  <!-- 查看大图缩略图 -->
  <el-dialog :visible.sync="isShowThumbnailImageDialog" @closed="clearThumbnailImg" title='图片查看' width="96%" top="50px" class="pub_dialog">
    <div class="imgDiv">
      <img :src='imgBigUrl'>
    </div>
    <div class="imgFiveDiv">
      <img v-for="(itemImg, index) in imgList" :key='index' :src="itemImg" @click="imgBigUrl = itemImg">
    </div>
  </el-dialog>
</section>
</template>
<script>
import { uploadOSS } from '../../utils/oss'; // oss上传
import { getOssFile, provincegetcountys } from '../../api/newOss';
import { getUserPurchasingByConditionForList, getUserPurchasingDetailById, getkind,
  getUpdatePurchasingStatusByUploadContract } from "../../api/api";

export default {
  name: 'CustomerPurchaseOrder',
  data() {
    return {
      show3: true,
      imgList:[],
      imgBigUrl:'',
      PurchasingAgentDialog: false, // 抽屉详情
      detailId: "", // 代购单id
      timer: null,
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      provinceId: 0,
      cityId: 0,
      zoneId: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      statusoptions: [],
      isShowThumbnailImageDialog: false, // 查看缩略图大图
      filters: {
        purchasingNo: "", // 代购单号
        chengshi: '', // 所属城市
        statusId: 0, // 代购状态
        phone: "", // 客户电话
        minPurchasingPrice: "", // 最低代购价
        maxPurchasingPrice: "" // 最高代购价
      },
      orderdetailList: [], // 详情基本信息
      // formDetails: [], // 详情页代购商品列表
      flag: 0,
      detailImgUrlarr: [], // 详情页图片
      detailImgIdarr: [], // 详情页图片id
      finalPurchasePrice: "", // 最终代购价格
      serviceFeeRate: "", // 代购服务费比例
      PurchasingGoodsListsImages: [], // 代购清单
      queryId: ''
    }
  },
  methods: {
    //查询列表
    getorder() {
      let that = this;
      let addParams = {
        userId: localStorage.Id, // 当前操作人id
        purchasingNo: this.filters.purchasingNo, // 代购单号
        provinceId: this.provinceId, // 省份id
        cityId: this.cityId, // 城市id
        zoneId: this.zoneId, // 所属区域id
        statusId: this.filters.statusId, // 状态
        phone: this.filters.phone, // 代购客户电话
        minPurchasingPrice: this.filters.minPurchasingPrice, // 最低代购价
        maxPurchasingPrice: this.filters.maxPurchasingPrice, // 最高代购价
        consumptionUserId: this.queryId, // consumptionUserId
        pageIndex: this.pageIndex, // 分页数据 当前页码
        pageSize: 10, // 分页数据 每页显示条数
      };
      getUserPurchasingByConditionForList(addParams).then(data => {
          this.dataList = data.ResultObj;
          this.total = data.RowsCount;
        })
        .catch(err => {
          this.dataList = [];
        });
    },
    // 查看
    seeOrder(id) {
      this.detailId = id;
      this.PurchasingAgentDialog = true;
      this.getOrderDetail(id); // 调用查询订单接口
    },
    // 查询订单详情
    getOrderDetail(id){
      var addParams = {
        purchasingId: id // 代购单id
      };
      getUserPurchasingDetailById(addParams).then(data => {
        data = data.ResultObj;
        this.orderdetailList = data;
        // this.formDetails = data.PurchasingGoods;
        this.detailImgUrlarr = data.PurchasingContractImg;
        this.flag = this.detailImgUrlarr.length;
        this.PurchasingGoodsListsImages = data.PurchasingGoodsListsImages;
        // 最终代购价 默认当前代购单的代购价，修改代购价后覆盖原有的代购价和服务费
        this.finalPurchasePrice = this.orderdetailList.PurchasingPirce; // 最终代购价
        this.serviceFeeRate = this.orderdetailList.ServiceFeeRate; // 代购服务费比例
      })
    },
    // 关闭抽屉弹框
    cancelForm() {
      this.PurchasingAgentDialog = false;
      clearTimeout(this.timer);
    },
    // 修改代购最终价格，并上传代购合同
    endUploadContract() {
      if (this.finalPurchasePrice == "" || this.finalPurchasePrice == null || this.finalPurchasePrice == undefined) {
        this.$swal({
          type: "warning",
          text: "请输入最终的代购价格 !!!"
        });
        return false
      }
      var addParams = {
        purchasingId: this.detailId, // 代购单id
        userId: localStorage.Id, // 用户id
        imgUrls: this.detailImgUrlarr.map(item => item.ImgUrl.replace(localStorage.BaseOssUrl, '')).join(","), // 代购合同图片相对路径，以英文逗号分隔
        purchasingPrice: this.finalPurchasePrice // 最终代购价格
      };
      getUpdatePurchasingStatusByUploadContract(addParams).then(data => {
        if(data.ResultCode == 1){
          this.$swal({
            type: "success",
            text:"操作成功"
          });
          this.getorder();
          this.PurchasingAgentDialog = false;
        }else if(data.ResultCode in {0:0,2:2}){
          this.$swal({
            type:'error',
            text: data.ResultMsg,
          })
        }
      })
    },
    // 点击查看缩略图
    seePicture(row) {
      if (!row.ImgUrlList) {
        return
      }
      this.imgList = row.ImgUrlList;
      this.imgBigUrl = this.imgList[0];
      this.isShowThumbnailImageDialog = true;
    },
    // 关闭查看大图
    clearThumbnailImg(){
      this.isShowThumbnailImageDialog = false;
    },
    // 请选择省市
    handleChange(val) {
      this.provinceId = val[0];
      this.cityId = val[1];
      this.zoneId = val[2];
    },
    // 查找省+市+区
    getprovince() {
      var loginParams = {
        isopen: 1, // 是否开放 -1=查全部 1=开放、0=未开放
      };
      provincegetcountys(loginParams).then(data => {
        let that = this;
        let provinceAndCityAndarea = [];
        data.resultObj.forEach(item => {
          // 所有省 查当前省下级市
          let provinceData = {value:item.pid,label:item.pname,children:[]};
          provinceAndCityAndarea.push(provinceData);
          // 所有市
          item.citys.map(city => {
            let cityData = {value:city.cid, label:city.cname,children:[]};
            provinceData.children.push(cityData);
            // 区
            city.countys.map(zone => {
              cityData.children.push({value:zone.scid, label:zone.scname});
            })
          })
        });
        that.options = provinceAndCityAndarea;
      })
    },
    // 获取代购状态
    getorderstatus() {
      let that = this;
      var addParams = {
        tableName: "tBDPurchasingStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(addParams).then(data => {
          let newdata = data.ResultObj;
          let obj = {
            Id: 0,
            Name: "全部"
          };
          newdata.unshift(obj);
          that.statusoptions = newdata;
        })
    },
    // 重置
    fnReset() {
      this.filters = {
        purchasingNo: "", // 代购单号
        chengshi: '', // 所属城市
        statusId: 0, // 代购状态
        phone: "", // 客户电话
        minPurchasingPrice: "", // 最低代购价
        maxPurchasingPrice: "" // 最高代购价
      },
      this.provinceId = 0;
      this.cityId = 0;
      this.zoneId = 0;
      this.queryId = '';
      // this.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.pageIndex = 1;
      if(Number(this.filters.minPurchasingPrice) && Number(this.filters.maxPurchasingPrice)) {
        // 如果代购价格 最低值大于了 最高值
        if (Number(this.filters.minPurchasingPrice) > Number(this.filters.maxPurchasingPrice)) {
          this.$swal({
            type: "warning",
            text: "代购价格最低值不得大于最高值 !!!"
          });
          return
        }
      }
      this.getorder();
    },
    // 上传图片
    beforeAvatarUpload(file) {
      // 判断图片格式
      const isJPG = file.type === 'image/png' || file.type === 'image/jpg' ||file.type === 'image/jpeg';
      // 判断图片大小
      const isLt2M = file.size / 1024 / 1024 <= 1;
      if (!isJPG) {
        this.$swal({
          type: "warning",
          text: "上传图片只支持jpg、png等格式!"
        });
        return;
      }
      if (!isLt2M) {
        this.$swal({
          type: "warning",
          text: "上传图片大小不能超过 1MB!"
        });
        return;
      }
      var _this = this;
      this.flag += 1;
      if (this.flag > 5) {
        this.$swal({
          type: "warning",
          text: "最多传入5张图片"
        });
        return false;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = async function(e) {
        // oss 直传图片
        var obj = {type: 5};
        getOssFile(obj).then(data => {
          if (data.resultCode == 1) {
            let ossId = data.resultObj.accesskeyid; // 登录RAM账户id
            let ossSecret = data.resultObj.accesskeysecret; // 登录RAM账户密码
            let ossHost = data.resultObj.hostendpoint; // 请求的OSS服务端点
            let ossfile = data.resultObj.directory; // 保存路径
            let ossbucket = data.resultObj.bucket; // bucket
            localStorage.setItem('keyossId',ossId);
            localStorage.setItem('keyossSecret',ossSecret);
            localStorage.setItem('keyossHost',ossHost);
            localStorage.setItem('keyossfile',ossfile);
            localStorage.setItem('keyossbucket',ossbucket);
            
          }
        })
        var newOssPic = await uploadOSS(file,0);
        _this.detailImgUrlarr.push({ImgUrl:newOssPic})
        // _this.detailImgUrlarr.push(newOssPic);
        
      };
      return file;
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getorder();
    },
    
    // 关闭el-image遮罩层
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        let domImageMask = document.querySelector('.el-image-viewer__mask')
        if (!domImageMask) {
          return
        }
        domImageMask.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
        
        this.$nextTick(() => {
          const mask = document.querySelector('.el-image-viewer__mask');
          const close = document.querySelector('.el-image-viewer__close');
          if (!mask || !close) return;

          // 先销毁旧事件
          mask.onclick = null;
          mask.onclick = () => close.click();
        });
        
      })
    },

  },
  computed: {
    "monitorServiceCharge"() {
      let rate = this.finalPurchasePrice * this.serviceFeeRate;
      if (isNaN(rate)) {
        return 0;
      }
      return rate;
    }
  },
  created() {
    let that = this;
    // 获取省
    this.getprovince();
    // 获取状态
    this.getorderstatus();
    this.queryId = this.$route.query.consumptionUserId;
    // 查询列表
    setTimeout(function() {
      that.getorder();
    }, 200);
  }
}
</script>
<style scoped>
.daigouUp{
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #eee;
  margin-right:10px;
}
.drawer_div {
  width: 96%;
  margin: 0 auto;
}
.watch_first {
  text-align: right;
  color: #888;
  width: 150px;
}
.drawer_title {
  padding-left: 0;
  display: flex;
  justify-content: space-between;
}
.drawer_title>li:first-child{
  font-size: 17px;
  font-weight: bolder;
  color: #333;
}
.drawer_foot {
  width: 100%;
  height: 100px;
  text-align: center;
  margin: 10px 0;
  display: inline-table;
}
.upPictures {
  width: 100%;
  margin-top: 10px;
  display: flex;
}
.detailedListBottom {
  width: 100%;
  margin: 10px 0;
  display: inline-block;
}
.labelInput {
  width: 80%;
  height: 60px;
  line-height: 50px;
  margin: 0 auto;
}
.divHone {
  width: 100%;
  height: 36px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
}
.divHone>div:first-child {
  font-weight: bold;
  font-size: 15px;
  color: #888;
}
.purchasingGoods {
  width: 100%;
  padding-top: 10px;
  font-weight: bold;
  font-size: 15px;
  color: #888;
}
.divP {
  width: 100%;
  height: 30px;
  clear: both;
}
.divP>p {
  color: #888;
}
.pub_dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
}
.imgDiv {
  width: 100%;
  height: 60vh;
  overflow: scroll;
  margin: 0 auto;
  text-align: center;
}
.imgDiv>img {
  /* width: 100%; */
  height: 100%;
}
.imgFiveDiv {
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: flex-start;
  overflow: scroll;
}
.imgFiveDiv>img {
  width: 160px;
  height: 100px;
  flex-wrap: nowrap;
  margin-right: 15px;
  border: 1px solid #ccc;
  padding: 5px;
  cursor: pointer;
}
.imgDialog {
  width: 100%;
  height: 500px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.imgDialog>img {
  width:auto; 
  height:auto; 
  max-width:100%; 
  max-height:100%;
  border-radius: 3px;
}
</style>


// WEBPACK FOOTER //
// CustomerPurchaseOrder.vue?6b764abd